export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangePhoneDialog.json?hash=027aa785042b666fcd992f6e9212117f";